<template>
  <div
    class="flex items-center border border-gray-300 hover:border-blue-800 rounded p-2 cursor-pointer min-h-11"
    @click="$emit('click')"
  >
    <span
      v-if="regionId && !isWorldRegion"
      class="font-semibold text-blue-800 uppercase"
    >
      {{ regionId }}
    </span>
    <svg-icon
      v-else
      name="globe"
      class="inline icon-md mx-1 cursor-pointer text-gray-400"
    />
  </div>
</template>

<script>
export default {
  props: {
    region: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    regionId() {
      return this.region ? this.region.Id : "";
    },
    isWorldRegion() {
      return this.regionId === "world";
    },
  },
};
</script>
